import type { PayoutMethod } from "@prisma/client";

export const CRYPTO_OPTIONS = [
	{ value: "BITCOIN", label: "Bitcoin (BTC)", icon: "/payment-icons/bitcoin-btc-logo.png" },
	{ value: "LITECOIN", label: "Litecoin (LTC)", icon: "/payment-icons/litecoin-ltc-logo.png" },
	{ value: "MONERO", label: "Monero (XMR)", icon: "/payment-icons/monero-xmr-logo.png" },
	{ value: "SOLANA", label: "Solana (SOL)", icon: "/payment-icons/solana-sol-logo.png" },
	{ value: "USDT", label: "Tether (USDT)", icon: "/payment-icons/tether-usdt-logo.png" },
] as const satisfies readonly { value: PayoutMethod; label: string; icon: string }[];

// Affiliate-facing type accepts the full Prisma enum. CRYPTO_OPTIONS is the
// legacy display set; PartnerHub-orchestrated payouts use the network-explicit
// values (USDT_TRON, USDC_POLYGON, …) and resolve legacy USDT at payout time.
export type CryptoMethod = PayoutMethod;

export const CRYPTO_LABELS: Record<string, string> = Object.fromEntries(
	CRYPTO_OPTIONS.map((opt) => [opt.value, opt.label]),
);

export const CRYPTO_ICONS: Record<string, string> = Object.fromEntries(
	CRYPTO_OPTIONS.map((opt) => [opt.value, opt.icon]),
);

export const FREQUENCY_OPTIONS = [
	{ value: "WEEKLY", label: "Weekly" },
	{ value: "BIWEEKLY", label: "Bi-weekly" },
	{ value: "MONTHLY", label: "Monthly" },
] as const;

export type PayoutFrequency = (typeof FREQUENCY_OPTIONS)[number]["value"];

export const FREQUENCY_LABELS: Record<string, string> = Object.fromEntries(
	FREQUENCY_OPTIONS.map((opt) => [opt.value, opt.label]),
);
